import { PlainButton, Tooltip } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import { collapsedIconButtonClassName } from "../../../../consts";
import { TicketsSidebarCount } from "./components/TicketsSidebarCount";

export const NavItem: FC<{
  label: string;
  icon: ReactNode;
  isActive: boolean;
  isExpanded: boolean;
  count?: number;
  isDisconnected?: boolean;
  onClick: () => void;
}> = ({
  label,
  icon,
  isActive,
  isExpanded,
  count,
  isDisconnected,
  onClick,
}) => {
  const hasCount = typeof count === "number";

  if (!isExpanded) {
    return (
      <Tooltip
        placement="right"
        renderTrigger={({ props, ref }) => (
          <PlainButton
            ref={ref}
            {...props}
            className={cx(
              collapsedIconButtonClassName,
              "mx-auto h-8 w-8",
              isActive &&
                "border-grey-200 bg-grey-200 hover:border-grey-200 hover:shadow-[inset_0_0_0_1px_#F2F2F4] focus-visible:shadow-[inset_0_0_0_1px_#F2F2F4]"
            )}
            onClick={onClick}
          >
            {icon}
          </PlainButton>
        )}
      >
        {label}
      </Tooltip>
    );
  }

  return (
    <PlainButton
      onClick={onClick}
      className={cx(
        "flex h-8 w-full items-center justify-between gap-2 rounded-[10px] px-3 text-left font-secondary transition-colors hover:bg-grey-100",
        isActive && "bg-grey-100"
      )}
    >
      <div className="flex w-full items-center gap-2 truncate">
        {icon}
        <span
          className={cx(
            "truncate font-secondary text-sm leading-[140%] text-[#4F4F4F] transition-colors",
            isActive && "font-medium text-black"
          )}
        >
          {isDisconnected && "⚠️ "}
          {label}
        </span>
      </div>
      {hasCount && <TicketsSidebarCount count={count} />}
    </PlainButton>
  );
};
